function preservarCapitalizacao(original: string, substituto: string): string {
  if (!original) {
    return substituto;
  }

  if (original === original.toUpperCase()) {
    return substituto.toUpperCase();
  }

  if (original.startsWith(original[0].toUpperCase())) {
    return substituto.charAt(0).toUpperCase() + substituto.slice(1);
  }

  return substituto;
}

const SUBSTITUICOES: Array<[RegExp, string]> = [
  [/\bexite\b/gi, 'existe'],
  [/\bja\b/gi, 'já'],
  [/\bnao\b/gi, 'não'],
  [/\bvoce\b/gi, 'você'],
  [/\bcapitulos\b/gi, 'capítulos'],
  [/\bcapitulo\b/gi, 'capítulo'],
  [/\bnumero\b/gi, 'número'],
  [/\bpagina\b/gi, 'página'],
  [/\bsituaçao\b/gi, 'situação'],
  [/\bsituacao\b/gi, 'situação'],
  [/\besta(?=\s+tentando)/gi, 'está'],
];

export function corrigirTextoPtBr(texto: unknown): string {
  let resultado = '';

  if (typeof texto === 'string') {
    resultado = texto;
  } else if (Array.isArray(texto)) {
    resultado = texto.filter((item): item is string => typeof item === 'string').join(' ');
  } else {
    return '';
  }

  for (const [regex, substituto] of SUBSTITUICOES) {
    resultado = resultado.replace(regex, (match: string) => preservarCapitalizacao(match, substituto));
  }

  return resultado;
}
